class VehicleMaintenance {
    constructor(
        id,
        clientID,
        vehicleID,
        accountID, 
        description,
        isolated,
        hadCost,
        cost,
        costResponsibility
    ) {
        this.id = id,
        this.clientID = clientID,
        this.vehicleID = vehicleID,
        this.accountID = accountID,
        this.description = description,
        this.isolated = isolated,
        this.hadCost = hadCost,
        this.cost = cost,
        this.costResponsibility = costResponsibility
    }
}

export const vehicleMaintenanceDefault = () => {
    const maintenance = {
        id: 0,
        clientID: 0,
        vehicleID: 0,
        accountID: null,
        description: "",
        isolated: false,
        hadCost: false,
        cost: null,
        costResponsibility: null,
        costFormatted: ""  
    }
    return maintenance
}

export default VehicleMaintenance